import { Helmet } from "react-helmet-async";

const SITE_NAME = "Xurray Mart";
const DEFAULT_DESC = "Xurray Mart is a modern marketplace designed to connect buyers and sellers, creating trusted opportunities to discover, showcase, and trade a wide range of quality products across diverse categories. Discover. Connect. Buy. Sell. Grow.";
const DEFAULT_IMAGE = "https://xurray.com/og-image.jpg";

// Dynamic SEO + Open Graph / Twitter meta for any page.
export const Seo = ({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  price,
  currency = "EUR",
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Connecting Buyers & Sellers`;
  const url = typeof window !== "undefined" ? window.location.href.split("#")[0] : "";
  const desc = (description || DEFAULT_DESC).slice(0, 300);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      {type === "product" && price != null && <meta property="product:price:amount" content={String(price)} />}
      {type === "product" && price != null && <meta property="product:price:currency" content={currency} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
